import React from 'react';
import styled from '@emotion/styled';
import { Flex } from 'reflexbox';
import { MARKETING_PAGE_BREAKPOINT_DESKTOP } from '../../../Style/breakpoints';

const Container = styled(Flex)`
  padding: 0;

  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    justify-content: center;
    padding: 0px;
  }
`;
const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  img {
    display: 100%;
    width: 100%;
    height: auto;
    max-width: 80px;
  }
  @media only screen and (max-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    img {
      max-width: 60px;
    }
  }
  @media only screen and (max-width: 460px) {
    margin-right: 10px;
    img {
      max-width: 30px;
    }
  }
`;

const Content = styled.div`
  display: flex;
  flex-flow: column;
  padding-left: 14px;
  justify-content: center;
  @media only screen and (max-width: 460px) {
    padding-left: 0px;
  }
`;

const Header = styled.div`
  font-family: Avenir, sans-serif;
  font-style: normal;
  font-weight: 800;
  font-size: 22px;
  line-height: 120%;
  letter-spacing: -0.01em;
  color: #041416;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    font-weight: 900;
    font-size: 26px;
  }
`;

const Description = styled.div`
  font-family: Avenir, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 140%;
  color: #3e4b4c;
`;

export const PlatformStat = React.memo(
  ({
    icon,
    header,
    description,
  }: {
    icon: React.ReactNode;
    header: string;
    description: string;
  }) => {
    return (
      <Container>
        <ImageContainer>{icon}</ImageContainer>
        <Content>
          <Header>{header}</Header>
          <Description>{description}</Description>
        </Content>
      </Container>
    );
  }
);
